const SYMBOL = "XEQT.TO"
const CACHE_KEY = "xeqt_price_cache"
const CACHE_TTL = 5 * 60 * 1000 // 5 minutes

function getCachedPrice() {
  try {
    const cached = sessionStorage.getItem(CACHE_KEY)
    if (!cached) return null
    const { data, timestamp } = JSON.parse(cached)
    if (Date.now() - timestamp > CACHE_TTL) return null
    return data
  } catch {
    return null
  }
}

function setCachedPrice(data) {
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify({ data, timestamp: Date.now() }))
  } catch {
    // sessionStorage unavailable
  }
}

async function fetchXeqtPrice() {
  const cached = getCachedPrice()
  if (cached) return cached

  const url = `https://query1.finance.yahoo.com/v8/finance/chart/${SYMBOL}?interval=1d&range=2d`
  const response = await fetch(url)
  if (!response.ok) throw new Error(`HTTP ${response.status}`)

  const json = await response.json()
  const result = json.chart.result[0]
  const meta = result.meta
  const price = meta.regularMarketPrice
  const previousClose = meta.chartPreviousClose
  const change = price - previousClose
  const changePercent = (change / previousClose) * 100

  const data = {
    price: price.toFixed(2),
    change: change.toFixed(2),
    changePercent: changePercent.toFixed(2),
    currency: meta.currency || "CAD",
    marketState: meta.currentTradingPeriod?.regular ? "regular" : "closed",
  }

  setCachedPrice(data)
  return data
}

function renderPrice(container, data) {
  const isPositive = parseFloat(data.change) >= 0
  const sign = isPositive ? "+" : ""
  const dirClass = isPositive ? "price-up" : "price-down"
  const arrow = isPositive ? "\u25B2" : "\u25BC"

  container.innerHTML = `
    <span class="price-ticker__symbol">XEQT.TO</span>
    <span class="price-ticker__price">$${data.price} <span class="price-ticker__currency">${data.currency}</span></span>
    <span class="price-ticker__change ${dirClass}">
      ${arrow} ${sign}${data.change} (${sign}${data.changePercent}%)
    </span>
  `
  container.classList.add("price-ticker--loaded")
}

export function initXeqtPriceTicker() {
  const container = document.getElementById("xeqt-price-ticker")
  if (!container) return

  fetchXeqtPrice()
    .then((data) => renderPrice(container, data))
    .catch(() => {
      // Silently hide on failure — the widget is progressive enhancement
      container.remove()
    })
}
